'use client';

import Script from 'next/script';

const RootScripts: React.FC = () => {
  const themeInit = `
    try {
      const theme = localStorage.getItem("theme");
      const shouldBeDark = theme !== "light";
      // Mirror SSR: set cookie so server can match class
      document.cookie = 'theme=' + (shouldBeDark ? 'dark' : 'light') + '; path=/; SameSite=Lax';
      document.documentElement.classList.add("no-transitions");
      document.documentElement.classList.toggle("dark", shouldBeDark);
      document.documentElement.classList.toggle("light", !shouldBeDark);
      requestAnimationFrame(() => {
        document.documentElement.classList.remove("no-transitions");
      });
    } catch (e) {}
  `;

  const netlifyRumRewrite = (
    process.env.NEXT_PUBLIC_NETLIFY_HOST
      ? `
    (function() {
      var host = location.hostname;
      var isVT = /(^|\\.)vtstaging\\.com$/.test(host) || /(^|\\.)varsitytutors\\.com$/.test(host);
      if (!isVT) return;

      var desiredSrc = '${new URL('/.netlify/scripts/rum', process.env.NEXT_PUBLIC_NETLIFY_HOST).toString()}';

      function replaceRumScript() {
        var el = document.getElementById('netlify-rum-container');
        if (!el) return false;
        el.remove();
        var newScript = document.createElement('script');
        newScript.async = true;
        newScript.id = 'netlify-rum-container';
        newScript.src = desiredSrc;
        var token = el.getAttribute('data-netlify-cwv-token');
        if (token) newScript.setAttribute('data-netlify-cwv-token', token);
        document.body.appendChild(newScript);
        return true;
      }

      if (replaceRumScript()) return;

      var observer = new MutationObserver(function() {
        if (replaceRumScript()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function(){ observer.disconnect(); }, 5000);
    })();
  `
      : ''
  ) as string;

  const newRelicInit = (
    process.env.NEW_RELIC_LICENSE_KEY &&
    process.env.NEW_RELIC_BROWSER_APPLICATION_ID &&
    process.env.NEW_RELIC_ACCOUNT_ID
      ? `
    (function() {
      window.NREUM = window.NREUM || {};
      window.NREUM.init = {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] }
      };
      window.NREUM.loader_config = {
        accountID: "${process.env.NEW_RELIC_ACCOUNT_ID}",
        trustKey: "${process.env.NEW_RELIC_ACCOUNT_ID}",
        agentID: "${process.env.NEW_RELIC_BROWSER_APPLICATION_ID}",
        licenseKey: "${process.env.NEW_RELIC_LICENSE_KEY}",
        applicationID: "${process.env.NEW_RELIC_BROWSER_APPLICATION_ID}"
      };
      window.NREUM.info = {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "${process.env.NEW_RELIC_LICENSE_KEY}",
        applicationID: "${process.env.NEW_RELIC_BROWSER_APPLICATION_ID}",
        sa: 1
      };
      var script = document.createElement("script");
      script.src = "https://js-agent.newrelic.com/nr-loader-spa-1.293.0.min.js";
      script.async = true;
      document.head.appendChild(script);
    })();
  `
      : ''
  ) as string;

  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: themeInit }} />
      {netlifyRumRewrite && (
        <Script id="netlify-rum-rewrite" strategy="afterInteractive">
          {netlifyRumRewrite}
        </Script>
      )}
      {newRelicInit && (
        <script dangerouslySetInnerHTML={{ __html: newRelicInit }} />
      )}
    </>
  );
};

export default RootScripts;
